export default __webpack_public_path__ + "static/estrutura-3-8e9ef6030e2f5c1fdbd5c51e0bc71db5.png";